import { useMemo } from 'react';

import { useOverrideIdContext } from 'contexts/OverrideIdContext';
import { useLocation } from 'react-router-dom';

import useRequiredParams from '@polyai/common/hooks/useRequiredParams';

export const SAMPLE_PROJECT_ACCOUNT_ID = 'SAMPLE_PROJECT_ACCOUNT';

const useProjectRoute = <Extra extends { [key: string]: string } = {}>() => {
  const { accountId: accountIdOverride, projectId: projectIdOverride } =
    useOverrideIdContext();
  const params = useRequiredParams<
    {
      projectId: string;
      accountId: string;
    } & Extra
  >();
  const location = useLocation();

  const isSampleProjectRoute = useMemo(
    () => location.pathname.startsWith('/templates/'),
    [location.pathname],
  );

  return {
    ...params,
    accountId:
      accountIdOverride ??
      (isSampleProjectRoute ? SAMPLE_PROJECT_ACCOUNT_ID : params.accountId),
    projectId: projectIdOverride ?? params.projectId,
  };
};

export default useProjectRoute;
